import { render, staticRenderFns } from "./manage-selector.vue?vue&type=template&id=60101356&scoped=true&"
import script from "./manage-selector.vue?vue&type=script&lang=ts&"
export * from "./manage-selector.vue?vue&type=script&lang=ts&"
import style0 from "./manage-selector.vue?vue&type=style&index=0&id=60101356&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60101356",
  null
  
)

export default component.exports